import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { MapClientSdkToWebSdk } from '@sxm-de/dev-kits/web-sdk/utils';

type PartnerEntitlement = {
    id: string;
    subscriptionId: string;
    productId: string;
    status: PartnerEntitlementStatus;
};

type PartnerEntitlementStatus =
    | 'PENDING'
    | 'ACTIVE'
    | 'SUSPENDED'
    | 'CANCELLED'
    | 'REVOKED';

export async function getPartnerEntitlement(
    {
        subscriptionId,
        productId,
    }: { subscriptionId: string; productId: string },
    dependencies: DependenciesPayload,
): Promise<PartnerEntitlement | null> {
    const { clientSdk } = dependencies;

    const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
        Awaited<
            ReturnType<
                typeof clientSdk.commerce.partnerEntitlements.getPartnerEntitlements
            >
        >,
        PartnerEntitlement[]
    > = (response) => {
        const entitlements: PartnerEntitlement[] = [];
        response.partnerEntitlements?.forEach((entitlement) => {
            entitlements.push({
                id: entitlement.id,
                subscriptionId: entitlement.subscriptionId,
                productId: entitlement.productId,
                status: entitlement.status,
            });
        });
        /**
         * TODO:
         * Add analytics.
         */
        return entitlements;
    };

    const entitlements = mapClientSdkToWebSdk(
        await clientSdk.commerce.partnerEntitlements.getPartnerEntitlements(),
    );
    const partnerEntitlement = entitlements?.find(
        (entitlement) =>
            entitlement.subscriptionId === subscriptionId &&
            entitlement.productId === productId,
    );

    return partnerEntitlement || null;
}
